import { extractListRows } from 'domain/feature/hub/company/meeting-room/shared/apiResponse'
import { postCall } from 'sharedKernel/api'
import { ApprovedReservationSlot } from '../availabilityRules'
import { PUBLIC_MEETING_ROOM_API } from './constants'
import { buildListByStatusPayload, YearMonth } from './listByStatusRequest'
import { PublicReservationByStatusDto } from './types'

const toDateOnly = (value?: string | null): string => String(value ?? '').match(/^\d{4}-\d{2}-\d{2}/)?.[0] ?? ''

const toTimeOnly = (value?: string | null): string => {
  const match = String(value ?? '').trim().match(/^(\d{1,2}):(\d{2})/)
  return match != null ? `${match[1].padStart(2, '0')}:${match[2]}` : ''
}

const toSlot = (item: unknown): ApprovedReservationSlot | null => {
  if (item == null || typeof item !== 'object') return null
  const dto = item as PublicReservationByStatusDto
  const startDate = toDateOnly(dto.reservationDate)
  if (!dto.id || !dto.meetingRoomId || !startDate) return null
  const endDate = toDateOnly(dto.endDate)
  return {
    id: String(dto.id),
    meetingRoomId: String(dto.meetingRoomId),
    meetingRoomName: dto.meetingRoomName?.trim() ?? '',
    startDate,
    endDate: endDate && endDate >= startDate ? endDate : startDate,
    startTime: toTimeOnly(dto.startTime),
    endTime: toTimeOnly(dto.endTime),
  }
}

// PLA-3423: reservas aprovadas (status default do endpoint) das salas informadas que tocam o mês.
export const fetchApprovedReservationsForMonth = async (
  yearMonth: YearMonth,
  meetingRoomIds: string[]
): Promise<ApprovedReservationSlot[]> => {
  const response = await postCall({
    url: PUBLIC_MEETING_ROOM_API.LIST_BY_STATUS,
    isPublic: true,
    data: buildListByStatusPayload(yearMonth, meetingRoomIds),
  })
  return extractListRows(response.data)
    .map(toSlot)
    .filter((slot): slot is ApprovedReservationSlot => slot != null)
}
